import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceProductsApi } from "@/services/products/index";
import type { ProductItemType } from "@/schemas/index";

const LayoutPageProduct = lazy(() => import("./layout/index"));

const loaderDataProduct = async (args: any) => {
  try {
    const { productId } = args.params;

    if (!productId) {
      throw new Error("PRODUCT_ID_REQUIRED");
    }

    const product =
      await serviceProductsApi.fetchProductFromParamUrl(productId);

    if (!product) {
      throw new Error("PRODUCT_NOT_FOUND");
    }

    const result = await Promise.all([
      serviceProductsApi.fetchProductRecommendedList(product.Id),
      serviceProductsApi.fetchProductRequiredList(product.Id),
    ]);

    return {
      product: product,
      recommendedProducts: result[0],
      requiredProducts: result[1],
    };
  } catch (err) {
    console.error(err);
  }
};

export const routerPageProduct: RouterItemType = {
  path: "/store/:productId",
  authorize: false,
  element: <LayoutPageProduct />,
  loader: loaderDataProduct,
};

export type loaderDataProductType = {
  product: ProductItemType;
  recommendedProducts: ProductItemType[];
  requiredProducts: ProductItemType[];
};
